import { Model } from 'app/model/backendmodel';
import {
    IAzureResource,
    IAzureResourceShadow,
    IDataSourceCredentialUrlResponse,
    ISOCDataLakeAnalyticsAccount
} from '../../interfaces/IAzureResource';
import { FactoryUrlInformationService } from '../factory-url-information.service';
import { LoggerService } from 'app/logger/logger.service';
import * as Constants from '../globals';
import { IMetadataClient } from '../base-metadata-client';
import { IFrameMessengerService } from '../iframe-messenger.service';
import { notImplementedFunction } from 'app/extension/api/common';
import { Trigger } from 'app/model/trigger/trigger';
import { Response } from '../http';
import { AuthConstants } from '../authentication/auth-constants';

export class IFrameMetadataClient implements IMetadataClient {
    public className = 'IFrameMetadataClient';
    protected authArea: string = AuthConstants.AUTH_AREA;

    public constructor(
        readonly urlService: FactoryUrlInformationService,
        readonly logger: LoggerService,
        public readonly iframeMessengerService: IFrameMessengerService
    ) {}

    public async getResource(resourceType?: Constants.ResourceType, resourceName?: string): Promise<IAzureResource> {
        return this.iframeMessengerService.getResourceAsync({
            contextData: undefined,
            workspaceObjectId: undefined,
            resourceType,
            resourceName,
            resourceObjectID: undefined
        }) as Promise<IAzureResource>;
    }

    public async update(resourceType: Constants.ResourceType, name: string, payload: {}): Promise<IAzureResource> {
        return new Promise<IAzureResource>((resolve, reject) => resolve(null));
    }

    public async rename(resourceType: Constants.ResourceType, name: string, payload: {}): Promise<Response> {
        return new Promise((resolve, reject) => resolve(null));
    }

    public async patch(resourceType: Constants.ResourceType, name: string, payload: {}): Promise<IAzureResource> {
        return new Promise<IAzureResource>((resolve, reject) => resolve(null));
    }

    public async create(resourceType: Constants.ResourceType, name: string, payload: {}): Promise<IAzureResource> {
        return new Promise<IAzureResource>((resolve, reject) => resolve(null));
    }

    public async deleteResource(
        resourceType: Constants.ResourceType,
        resourceName: string,
        retryBadRequest: boolean = false
    ): Promise<Response> {
        return new Promise((resolve, reject) => resolve(null));
    }

    public getSparkHistoryEndpoint(baseUri: string): Promise<string> {
        return notImplementedFunction();
    }

    public getSparkHistoryServerVersion(workspace: Model.Workspace): Promise<string> {
        return notImplementedFunction();
    }

    public getSOCDataLakeAnalyticsAccount(workspace: Model.Workspace): Promise<ISOCDataLakeAnalyticsAccount> {
        return notImplementedFunction();
    }

    public async listResources(resourceType: Constants.ResourceType): Promise<IAzureResource[]> {
        return this.iframeMessengerService.listResourcesAsync({
            contextData: undefined,
            workspaceObjectId: undefined,
            resourceType
        }) as Promise<IAzureResource[]>;
    }

    public async listResourceShadows(resourceType: Constants.ResourceType): Promise<IAzureResourceShadow[]> {
        return this.iframeMessengerService.listResourcesAsync({
            contextData: undefined,
            workspaceObjectId: undefined,
            resourceType
        }) as unknown as Promise<IAzureResourceShadow[]>;
    }

    public async getDataSourceCredentialUrl(lsName: string): Promise<IDataSourceCredentialUrlResponse> {
        return new Promise<IDataSourceCredentialUrlResponse>((resolve, reject) => resolve(undefined));
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public async getFirstPage(resourceType: Constants.ResourceType): Promise<any> {
        return this.listResources(resourceType);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public async getNextPage(nextLink: any): Promise<any> {
        return new Promise<void>((resolve, reject) => resolve());
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public getUAMI(): Promise<any> {
        return Promise.resolve(null);
    }

    public async queryTriggers(triggerFilter: Model.TriggerQueryFilter): Promise<Trigger[]> {
        return notImplementedFunction();
    }

    public getAuthArea(): string {
        return '';
    }

    public getBaseUri(): string {
        return '';
    }

    public async upgradeLinkedService(linkedServiceName: string): Promise<Response> {
        return notImplementedFunction();
    }
}
